import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { USE_STUB_DATA, STUB_BRANCHES } from "../../config/stubData";
import PageTransition from "../../components/common/PageTransition";
import {
  BuildingOfficeIcon,
  MagnifyingGlassIcon,
  ChevronRightIcon,
  MapPinIcon,
  UserGroupIcon,
  PhoneIcon,
  EnvelopeIcon,
  PlusIcon,
  PencilIcon,
  TrashIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../store";
import { selectUsers } from "../user/userSlice";
import {
  selectBranches,
  selectBranchLoading,
  selectBranchError,
  fetchBranches,
  removeBranch,
  updateBranchStatus
} from "./branchSlice";
// import { up }
import CreateBranchModal from "./CreateBranchModal";
import EditBranchModal from "./EditBranchModal";
import { Branch } from "./branch";
import toast from "react-hot-toast";
import FormControl from "@mui/material/FormControl";
import { InputLabel, MenuItem, Select } from "@mui/material";
import SearchBar from "../../components/searchbar";
import HeaderSection from "../../components/HeaderSection";
import DurationDropdown from "../../form/DurationDropdown";
import { usePermission } from "../../components/common/PermissionGuard";
import LoadingButton from "../../components/common/LoadingButton";
import PageWrapper from "../../components/common/PageWrapper";
import CloseConfirmationDialogue from "../../components/common/__tests__/CloseConfirmationDialogue";

const Branches: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const branches = useAppSelector(selectBranches);
  const loading = useAppSelector(selectBranchLoading);
  const error = useAppSelector(selectBranchError);
  const [searchQuery, setSearchQuery] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [closeDialog, setCloseDialog] = useState(false);
  const [editBranchModalOpen, setEditBranchModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null);
  const users = useAppSelector(selectUsers);
  const [status, setStatus] = useState("");

  const canWrite = usePermission("branches", "create")
  const canEdite = usePermission("branches", "update")

  const handleChange = (event: any) => {
    setStatus(event.target.value);
  };

  useEffect(() => {
    if (!USE_STUB_DATA) {
      dispatch(fetchBranches());
    }
  }, [dispatch]);

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
    setSelectedBranch(null);
    if (!USE_STUB_DATA) {
      dispatch(fetchBranches());
    }
  };

  const handleEditBranch = (branch: Branch) => {
    setSelectedBranch(branch);
    setIsCreateModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditBranchModalOpen(false);
    setSelectedBranch(null);
    if (!USE_STUB_DATA) {
      dispatch(fetchBranches());
    }
  };

  const handleDeleteBranch = async (branch: Branch) => {
    if (
      !window.confirm(
        `Are you sure you want to delete branch "${branch.name}"?`
      )
    )
      return;
    try {
      await dispatch(removeBranch(branch.id)).unwrap();
      toast.success("Branch deleted successfully");
      if (!USE_STUB_DATA) {
        dispatch(fetchBranches());
      }
    } catch (error) {
      toast.error("Failed to delete branch");
    }
  };

  const getBranchStats = (branchId: string) => {
    const branchUsers = users.filter((user) => user.branchId === branchId);
    return {
      totalUsers: branchUsers.length,
    };
  };

  const filteredBranches = branches.filter(
    (branch) =>
      searchQuery === "" ||
      branch.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      branch.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
      branch.state.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return (
      <PageTransition>
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          </div>
        </div>
      </PageTransition>
    );
  }

 
  


  const handleStatusChange = (branchId: string, status: boolean) => {
    dispatch(updateBranchStatus({ branchId, status }));
    console.log("Update branch", branchId, "to status:", status);

  };

  // if (error) {
  //   return (
  //     <PageTransition>
  //       <div className="container mx-auto px-4 py-8">
  //         <div className="flex items-center justify-center min-h-[400px]">
  //           <div className="text-center">
  //             <div className="mb-4">
  //               <BuildingOfficeIcon className="h-12 w-12 text-red-400 mx-auto" />
  //             </div>
  //             <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
  //               Error Loading Branches
  //             </h2>
  //             <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
  //             <button
  //               onClick={() => dispatch(fetchBranches())}
  //               className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
  //             >
  //               Retry
  //             </button>
  //             {/* <LoadingButton
  //             loadingKey="fetchBranches"
  //             onClick={() => dispatch(fetchBranches())}
  //             loadingText="Loading..."
  //             color="primary"
  //             variant="contained"
  //           >
  //             Retry
  //           </LoadingButton> */}
  //           </div>
  //         </div>
  //       </div>
  //     </PageTransition>
  //   );
  // }

  return (
    <PageTransition>
      <PageWrapper>
        
        {/* Header Section */}
        {/* <div className="flex justify-between items-center mb-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
                <BuildingOfficeIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">
                  Branches
                </h1>
                <p className="text-secondary-600 dark:text-secondary-400 mt-1">
                  Manage your organization's locations and facilities
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={() => setIsCreateModalOpen(true)}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:focus:ring-offset-secondary-800 transition-colors"
            >
              <PlusIcon className="h-5 w-5 mr-2" />
              Create Branch
            </button>
          </motion.div>
        </div> */}

        <HeaderSection
          title="Branches"
          description="Manage your organization's locations and facilities"
          icon={
            <BuildingOfficeIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          }
          
          buttonIcon={<PlusIcon className="h-5 w-5 mr-2" />}
          buttonText="Create Branch"
          onButtonClick={() => setIsCreateModalOpen(true)}
        />

        {/* <HeaderSection
          icon={<BuildingOfficeIcon />}
          title="Branches"
          description="Manage your branch settings"
          // icon={
          //   <BuildingOfficeIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          // }
          buttonText="Add Branch"
          buttonIcon={<PlusIcon className="h-4 w-4 mr-1" />}
          onButtonClick={() => setIsCreateModalOpen(true)}
          // showDurationDropdown // 👈 enable dropdown just here
        /> */}



        <div className="w-full flex-1 mb-5">
            <SearchBar
              placeholder="Search branches by name, city, or state..."
              value={searchQuery}
              // onChange={setSearchTerm}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

        {/* Stats Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
        >
          <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-sm p-6">
            <div className="text-secondary-600 dark:text-secondary-400">
              Total Branches
            </div>
            <div className="text-3xl font-bold text-secondary-900 dark:text-white mt-2">
              {branches.length}
            </div>
          </div>
          <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-sm p-6">
            <div className="text-secondary-600 dark:text-secondary-400">
              Active Branches
            </div>
            <div className="text-3xl font-bold text-secondary-900 dark:text-white mt-2">
              {branches.filter((branch) => branch.status).length}
            </div>
          </div>
          <div className="bg-white dark:bg-secondary-800 rounded-lg shadow-sm p-6">
            <div className="text-secondary-600 dark:text-secondary-400">
              Cities
            </div>
            <div className="text-3xl font-bold text-secondary-900 dark:text-white mt-2">
              {new Set(branches?.map((branch) => branch.city)).size}
            </div>
          </div>
        </motion.div>

        {/* Search Section */}
        <div className="mb-6">
          {/* <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search branches by name, city, or state..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div> */}
          {/* <div className="w-full flex-1">
            <SearchBar
              placeholder="Search branches by name, city, or state..."
              value={searchQuery}
              // onChange={setSearchTerm}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div> */}


          {/* <SearchBar
            placeholder="Search branches by name, city, or state..."
            value={searchQuery}
            // onChange={setSearchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          /> */}
          {/* <SearchBar
      label="Enter a city name"
      placeholder="Search..."
      value={searchQuery}
      onChange={setSearchQuery}
      // onSubmit={handleSearchSubmit}
    /> */}
        </div>

        {/* Branches List */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.4 }}
          className="bg-white dark:bg-secondary-800 rounded-lg shadow-sm overflow-hidden"
        >
          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            {filteredBranches.map((branch) => {
              const stats = getBranchStats(branch.id);
              return (
                <div
                  key={branch.id}
                  className="p-6 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                >
                  <div className="flex items-center justify-between">
                    {/* <div
                      className="flex-1 cursor-pointer"
                      onClick={() => navigate(`/branches/${branch.id}`)}
                    > */}
                    <div
                      className="flex-1 cursor-pointer"
                      onClick={(e) => {
                        // Prevent dropdown clicks from navigating
                        if (
                          !(e.target as HTMLElement).closest(
                            "select, input, button, [role='button']"
                          )
                        ) {
                          navigate(`/branches/${branch.id}`);
                        }
                      }}
                    >
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
                          {branch.name}
                          {/* <span
                            className={`ml-3 px-2 py-1 text-xs rounded-full ${
                              branch.status
                                ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                                : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                            }`}
                          >
                            {branch.status ? "Active" : "Inactive"}
                          </span> */}
                          
                          {/* <div className="px-4">
                            <FormControl
                              size="small"
                              className={`rounded-full text-xs min-w-[100px] ${
                                branch.status
                                  ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                                  : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                              }`}
                              sx={{
                                height: "28px",
                                justifyContent: "center",
                                // paddingX: 1,
                                // paddingY: 0,
                                paddingTop:0.5,
                                paddingLeft:2,
                                paddingRight:1,
                              }}
                            >
                              <Select
                                value={branch.status ? "true" : "false"}
                                onChange={(e) => {
                                  const newStatus = e.target.value === "true";
                                  handleStatusChange(branch.id, newStatus);
                                }}
                                onClick={(e) => e.stopPropagation()}
                                displayEmpty
                                variant="standard"
                                disableUnderline
                                className="text-center bg-transparent text-xs"
                                sx={{
                                  paddingY: "2px",
                                  paddingX: "4px",
                                  minHeight: "0",
                                }}
                                MenuProps={{
                                  PaperProps: { style: { fontSize: "0.75rem" } },
                                }}
                              >
                                <MenuItem value="true">Active</MenuItem>
                                <MenuItem value="false">Inactive</MenuItem>
                              </Select>
                            </FormControl>
                          </div> */}

                        </h3>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-500 dark:text-gray-400">
                        <div className="flex items-center">
                          <MapPinIcon className="h-5 w-5 mr-2" />
                          <span>
                            {branch.city}, {branch.state}
                          </span>
                        </div>
                        <div className="flex items-center">
                          <UserGroupIcon className="h-5 w-5 mr-2" />
                          <span>{stats.totalUsers} Users</span>
                        </div>
                        <div className="flex items-center">
                          <EnvelopeIcon className="h-5 w-5 mr-2" />
                          <span>{branch.email || "N/A"}</span>
                        </div>
                      </div>

                      <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        <span className="font-medium">Manager:</span>{" "}
                        {branch.managerName}
                      </div>
                    </div>
                    {canEdite && (
                    <div className="flex items-center space-x-2 ml-4">
                      <button
                        onClick={() => handleEditBranch(branch)}
                        className="p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
                        title="Edit"
                      >
                        <PencilIcon className="h-5 w-5 text-blue-500" />
                      </button>
                      {/* <button
                        onClick={() => handleDeleteBranch(branch)}
                        className="p-2 rounded hover:bg-gray-200 dark:hover:bg-gray-700"
                        title="Delete"
                      >
                        <TrashIcon className="h-5 w-5 text-red-500" />
                      </button> */}
                    </div>
                    )}
                    <ChevronRightIcon className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>

        {/* Create Branch Modal */}
        { canWrite &&(
        <CreateBranchModal
          isOpen={isCreateModalOpen}
          onClose={() => setCloseDialog(true)}
          onSuccess={() => {
            setIsCreateModalOpen(false);
            setSelectedBranch(null);
              dispatch(fetchBranches());
          }}
          branch={selectedBranch as Branch}
        />
        )}
        
        {closeDialog && (
          <CloseConfirmationDialogue
            open={closeDialog}
            onClose={() => setCloseDialog(false)}
            onConfirm={() => {
              setCloseDialog(false);
              setIsCreateModalOpen(false);
              setSelectedBranch(null);
            }}
            title=""
            message="Are you sure you want to close this branch model?"
          />
        )}

      </PageWrapper>
    </PageTransition>
  );
};

export default Branches;
